module.exports = __webpack_public_path__ + "static/img/zt1-pic1.3ede526.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/zt1-pic1.jpg
// module id = zkkG
// module chunks = 171